import { remove } from "@src/appV2/api/api";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib";
import {
  useMutation,
  type UseMutationOptions,
  type UseMutationResult,
} from "@tanstack/react-query";
import { type AxiosError } from "axios";
import z from "zod";

import { getCommentUrl } from "./getCommentUrl";

export interface DeleteCommentParams {
  workplaceId: string;
  commentId: string;
}

export function useDeleteComment(
  params: DeleteCommentParams,
  options: UseMutationOptions<void, AxiosError> = {}
): UseMutationResult<void, AxiosError, void> {
  return useMutation({
    mutationFn: async () => {
      await remove({
        url: getCommentUrl(params),
        responseSchema: z.literal(""),
      });
    },
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.DELETE_COMMENT_FAILURE,
    },
    ...options,
  });
}
